import type { Document } from "@/store/api/documentApi";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DocumentState {
  documents: Document | null;
}

const initialState: DocumentState = {
  documents: null,
};

const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setDocuments(state, action: PayloadAction<Document>) {
      state.documents = action.payload;
    },
    clearDocuments(state) {
      state.documents = null;
    },
  },
});

export const { setDocuments, clearDocuments } = documentSlice.actions;
export default documentSlice.reducer;
